import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { emailMsg, t } from '../../../common/i18n/index.js';
import { SelectRadio } from '../../../common/react-hook-form/components/SelectRadio.js';
import { Contact as ContactField } from '../../../common/react-hook-form/fields/Contact';
import { Email } from '../../../common/react-hook-form/fields/index.js';
import { ReceiverTypes } from '../../../common/utils/billingAccountUtils.js';
import { type Contact, ContactType } from '../../../generated/api/models.js';
import { GridColumn } from './GridColumn.js';

const OtherReceiver = ({
  billReceiver,
  changeReceiver,
  contacts,
  disabled,
  onClickChangeReceiver,
  onCreateContact,
}: {
  billReceiver: ContactType;
  changeReceiver: boolean;
  contacts: Contact[];
  disabled: boolean;
  onClickChangeReceiver: () => void;
  onCreateContact?: () => void;
}) => {
  if (billReceiver === ContactType.COMMON_FUNCTION && !changeReceiver) {
    return (
      <>
        <Email disabled={true} name="billingAccount.billReceiverName" label={t.OKYY(emailMsg)} />
        <CL.Button color="light" onClick={() => onClickChangeReceiver()}>
          {t.ETV2('Change receiver')}
        </CL.Button>
      </>
    );
  }

  return (
    <>
      <ContactField
        contacts={contacts || []}
        name="billingAccount.billReceiverId"
        reference="contact"
        onCreateContact={onCreateContact}
        disabled={disabled}
      />
      <div className={dsClass.DISPLAY_FLEX}>
        <CL.Icon icon="information" type="light" size="s" />
        <span className={`${dsClass.TEXT_SMALL} ${dsClass.MARGIN_LEFT_2}`}>
          {t.RJT5('Select a contact from the list or create a new one.')}
        </span>
      </div>
    </>
  );
};

export const BillReceiverEdit = ({
  disabled = false,
  contacts,
  onCreateContact,
}: {
  disabled?: boolean;
  contacts: Contact[];
  onCreateContact?: () => void;
}) => {
  const [changeReceiver, setChangeReceiver] = useState(false);
  const { watch } = useFormContext();
  const billReceiver = watch('billingAccount.billReceiverType');
  const billReceiverSelection = watch('billReceiverSelection');

  return (
    <>
      <CL.GridRow>
        <GridColumn className="of-billing-account-details form-column edit-left">
          <SelectRadio
            name="billReceiverSelection"
            disabled={disabled}
            items={[
              {
                label: t.ZCX7('Same as contact'),
                value: ReceiverTypes.SAME_AS_CONTACT,
              },
              {
                label: t.C6WY('Other'),
                value: ReceiverTypes.OTHER,
              },
            ]}
          />
        </GridColumn>
      </CL.GridRow>
      {billReceiverSelection === ReceiverTypes.OTHER && (
        <CL.GridRow>
          <GridColumn className="of-billing-account-details form-column edit-left">
            <OtherReceiver
              onClickChangeReceiver={() => setChangeReceiver(true)}
              changeReceiver={changeReceiver}
              billReceiver={billReceiver}
              disabled={disabled}
              contacts={contacts}
              onCreateContact={onCreateContact}
            />
          </GridColumn>
        </CL.GridRow>
      )}
    </>
  );
};
